export default __webpack_public_path__ + "static/media/Screenshot_14.f4a0464f.png";